<template>
	<div class="box grow scrollable only-y customer-invoices" :class="{ 'customer-invoices--centered': customerId != null }" id="page-panel">
		<resize-observer @notify="__resizeHanlder" />
		<el-tabs v-model="editableTabsValue"  v-if="isAdmin" :addable="true" @tab-add="openCreateDashboardDialog">
			<el-tab-pane>
				<span slot="label">
					<i class="mdi mdi-finance"></i> <strong> {{$t('dashboards.dashboardTabTitle')}}</strong>
				</span>
				<div style="display: flex; gap: 10px;" v-if="showReportingInventoriesSelection">
						<el-select 
							v-model="selectedReportingInventories" 
							multiple
							:loading="loadingInventories"
							collapse-tags 
							placeholder="Select">
							<el-option
								value-key="id"
							v-for="item in getInventoriesForReporting"
							:key="item.id"
							:label="item.name"
							:value="item.id">
							</el-option>
						</el-select>
				</div>
				
				<InfoStatCard12MonthsComparison :inventoryIds="selectedReportingInventories" class="m-10"></InfoStatCard12MonthsComparison>
				<div class="dashboard-secondary-kpis">
					<ReservationStatsCard :repId="isCurrentUserRep ? getCurrentUserId : null" class="dashboard-secondary-kpis__item"></ReservationStatsCard>
					<VisitStatsCard :repId="isAdmin ? null : getCurrentUserId" class="dashboard-secondary-kpis__item"></VisitStatsCard>
				</div>
				<el-row class="mt-20">
            		<salesGraphics :filters="salesEvolutionFilters" :title="evolutionTitle" :showQuantity="true" > </salesGraphics>
          		</el-row>
			</el-tab-pane>
			<el-tab-pane
				v-for="(d, index) in dashboards"
				:key="d.uuid"
				>
				<span slot="label">
					<el-badge :value="d.nbElement" class="item" v-if="d.nbElement > 0">
					{{ d.configuration.title }}
					</el-badge>
					<span v-else>{{ d.configuration.title }}</span>
				</span>
				
					<salesOrderDashboardCard v-if="d.name=='sales-order-dashboard'" :key="'so-' + d.uuid + '-' + (dashboardRefreshByUuid[d.uuid] || 0)" :height="pageHeight" :uuid="d.uuid" :position="d.position" :id="d.id" :dashboard="d" :filters="d.configuration.filters" :criterias="d.configuration.criterias" :defaultType="d.configuration.status_code" :salesReps="d.configuration.sales_reps" :title="d.configuration.title" :showDeliveryDate="true" :customerClasses="d.configuration.customerClasses" :inventories="d.configuration.inventories" :productId="d.configuration.productId" @configure="openEditDashboardDialog"></salesOrderDashboardCard>
					<reservationDashboardCard v-if="d.name=='reservation-dashboard'" :key="'res-' + d.uuid + '-' + (dashboardRefreshByUuid[d.uuid] || 0)" :height="pageHeight" :uuid="d.uuid" :position="d.position" :id="d.id" :dashboard="d" :filters="d.configuration.filters" :salesReps="d.configuration.sales_reps" :title="d.configuration.title" @configure="openEditDashboardDialog"></reservationDashboardCard>
					<invoiceDashboardCard v-if="d.name=='invoice-dashboard'" :key="'inv-' + d.uuid + '-' + (dashboardRefreshByUuid[d.uuid] || 0)" :height="pageHeight" :id="d.id" :uuid="d.uuid" :position="d.position" :dashboard="d" :filters="d.configuration.filters" :title="d.configuration.title" :criterias="d.configuration.criterias" :fields="d.configuration.fields" :salesReps="d.configuration.sales_reps" :customerClasses="d.configuration.customerClasses" :productId="d.configuration.productId" @configure="openEditDashboardDialog"></invoiceDashboardCard>
					<packageDashboardCard v-if="d.name=='package-dashboard'" :key="'pkg-' + d.uuid + '-' + (dashboardRefreshByUuid[d.uuid] || 0)" :height="pageHeight" :id="d.id" :uuid="d.uuid" :position="d.position" :dashboard="d" :filters="d.configuration.filters" :title="d.configuration.title" :inventories="d.configuration.inventories" @configure="openEditDashboardDialog"></packageDashboardCard>
				
			</el-tab-pane>
			
		</el-tabs>
		<dashboardDialog :visible="dashboardDialogVisible" @close="dashboardDialogVisible=false" @updated="handleDashboardUpdated" v-if="isAdmin"></dashboardDialog>
		<!-- <RepReservationsDashboard v-if="isCurrentUserRep" /> -->

		<div v-if="!isAdmin && !isCurrentUserRep && customer!=null">
			<div class="customer-portal-title">
				<img src="/logo.svg" alt="Portaus" class="customer-portal-title__logo">
				<span>Portaus - Portail client</span>
			</div>
			<transition name="panorama-offer-enter" appear>
			<div v-if="isCustomerLicencie" class="panorama-offer panorama-offer--animated card-base card-shadow--small mb-20">
				<div class="panorama-offer__left">
					<el-image src="/logo-panorama.png" fit="contain" class="panorama-offer__logo"></el-image>
					<div>
						<div class="panorama-offer__title">Passez en mode Panorama</div>
						<div class="panorama-offer__subtitle">Centralisez vos factures, reservations et commandes, gerez vos inventaires, accedez aux portfolios de la SAQ et des agences IP, et profitez d'un <strong>rabais de 125$ / mois pour les 3 premiers mois</strong>.</div>
					</div>
				</div>
				<div class="panorama-offer__actions">
					<el-link
						type="primary"
						:underline="false"
						:href="panoramaSignupUrl"
						target="_blank"
						class="panorama-offer__cta panorama-offer__cta--primary">
						S'inscrire a Panorama
					</el-link>
					<el-link
						type="info"
						:underline="false"
							href="https://panorama-portal.io/"
						target="_blank"
						class="panorama-offer__cta panorama-offer__cta--secondary">
						En savoir plus
					</el-link>
				</div>
			</div>
			</transition>

			<el-row class="mt-0" :gutter="30">
				<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
					<div class="card-base card-shadow--small mb-30 widget small-widget" v-loading="loadingStats">

						<div class="widget-header ph-20 pt-20">
							<div class="flex justify-center align-center">
								<div class="widget-icon-box mr-20 animated fadeInRight">
									<i class="widget-icon mdi mdi-bank accent-text fs-30"></i>

								</div>
								<div class="widget-info box grow text-truncate animated fadeInLeft">
									<div class="o-050 widget-title text-truncate pt-5 pb-10">{{$t('customer_portal.Balance')}}</div>
									<h2 class="m-0">{{$n(stats.balance,'currency', this.customer.currency.code)}}</h2>
									<span class="m-0 fs-12" v-if="nextPaymentDate!=null">{{$t('customer_portal.Next_payment_due')}} :{{moment(nextPaymentDate,'l')}}</span>
								</div>
								
							</div>
							<!-- <div class="m-10" style="text-align:left;">
								<el-button type="text" @click="downloadStatementReport">Télécharger mon état de compte</el-button>
							</div> -->
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
					<div class="card-base card-shadow--small mb-30 widget small-widget" v-loading="loadingStats">

						<div class="widget-header ph-20 pt-20">
							<div class="flex justify-center align-center">
								<div class="widget-icon-box mr-20 animated fadeInRight">
									<i class="widget-icon mdi mdi-cash-multiple accent-text fs-30"></i>

								</div>
								<div class="widget-info box grow text-truncate animated fadeInLeft">
									<div class="o-050 widget-title text-truncate pt-5 pb-10">{{$t('customer_portal.Credit')}}</div>
									<h2 class="m-0">{{$n(stats.credit,'currency', this.customer.currency.code)}}</h2>
								</div>

							</div>
							<!-- <div class="m-10" style="text-align:right;">
								<el-link type="primary" :disabled="true" @click="payInvoices" v-if="totalAmountDue>0">{{$t('customer_portal.Pay_balance')}}</el-link>
							</div> -->
						</div>
					</div>
				</el-col>
			</el-row>
			<CustomerPortalDocumentViewer :customer="customer" :customerId="customerId"></CustomerPortalDocumentViewer>

		</div>


	</div>
</template>
<script>


import dashboardDialog from '@/components/dashboards/dashboard-dialog.vue'
import RepReservationsDashboard from './RepReservationsDashboard.vue'
import CustomerAPI from '@/services/API/customer'
import CustomerPortalDocumentViewer from '@/components/invoice/customer-portal-document-viewer.vue'
import moment from 'moment-timezone'
import salesGraphics from '@/components/sales-graphic'
import InfoStatCard12MonthsComparison from '@/components/reports/Info-stat-card-12-month-comparison.vue'
import ReservationStatsCard from '@/components/reports/ReservationStatsCard.vue'
import VisitStatsCard from '@/components/reports/VisitStatsCard.vue'
// import InfoStatsCard from '@/components/Info-stat-card'
import { EventBus } from '@/core/event-bus'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'Dashboard',
	data () {
		return {
			customer : null,
			dashboardDialogVisible:false,
			dashboardRefreshByUuid: {},
			editableTabsValue: 0,
			pageWidth : 0,
	  		pageHeight : 0,
			tabIndex: 1,
			selectedReportingInventories: [],
			loadingInventories: false,
		}
	},
	computed: {
		evolutionTitle(){
			if (this.isCurrentUserRep === true) {
				return this.$i18n.t('reports.myEvolution12MonthsTitle')
			} else {
				return this.$i18n.t('reports.evolution12MonthsTitle')
			}

		},
		showReportingInventoriesSelection () {
			return _.size(this.getInventoriesForReporting) > 1;
		},
		salesEvolutionFilters () {
			if (this.isCurrentUserRep === true) {
				return {
					repId: this.loggedInUser,
					inventoryId: this.selectedReportingInventories,
				}	
			}  else {
				return {
					inventoryId: this.selectedReportingInventories,
				}	
			}
		
		},
		last12Month(){
		return {startDate : moment().subtract(12,'months').startOf('month'), endDate : moment().subtract(1,'months').endOf('month')}
		},
		getHeightStyle(){
			return "height:" + (this.pageHeight-242) + "px;";
		},
		customerId(){
			if(this.$store.getters.customerProfile){
					return this.$store.getters.customerProfile.id;
			}
			return null;
		},
		isAdmin(){
				return JSON.parse(localStorage.user).is_admin;
		},
		smallWidget() {
			return this.dashboardWidth >= 970 && this.dashboardWidth <= 1412 && this.windowWidth >= 1200
		},
		loggedInUser(){
			var user = JSON.parse(localStorage.user);
			return String(user.id);
		},
		customerClassInd () {
			return _.upperCase(
				_.get(this.customer, 'class.ind')
				|| _.get(this.customer, 'customer_class.ind')
				|| _.get(this.customer, 'customerClass.ind')
				|| ''
			);
		},
		isCustomerLicencie () {
			return this.customerClassInd === 'LICENCIE' || this.customerClassInd === 'LICENCEE';
		},
		panoramaSignupUrl () {
			return 'https://app.panorama-portal.io/register?refCode=PANPROMO';
		},
		...mapGetters('customerInvoices',['totalAmountDue','nextPaymentDate']),
		...mapState('customerInvoices', ['stats', 'loadingStats']),
		...mapGetters('inventory', ['getWinePrivateImportInventories', 'getInventoriesForReporting']),
		...mapState('genericDashboards', ['dashboards', 'loadingDashboards']),
		...mapGetters('genericDashboards', ['dashboardsUuid']),
		...mapGetters(['isCurrentUserRep', 'getCurrentUserId'])
	},
	methods: {
		openCreateDashboardDialog(){
			this.setCreateMode();
			this.dashboardDialogVisible = true;
		},
		openEditDashboardDialog(dashboard){
			this.setDashboardToEdit(dashboard);
			this.dashboardDialogVisible = true;
		},
		handleDashboardUpdated(dashboard){
			const uuid = _.get(dashboard, 'uuid');
			if (uuid == null) {
				return;
			}
			const currentVersion = this.dashboardRefreshByUuid[uuid] || 0;
			this.$set(this.dashboardRefreshByUuid, uuid, currentVersion + 1);
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
		downloadStatementReport(){
			let startDate = this.last12Month.startDate.format('YYYY-MM-DD');
			let endDate = this.last12Month.endDate.format('YYYY-MM-DD')
			let filename = "statement-"+ startDate +"-"+ endDate
			CustomerAPI.downloadStatementReport(this.customerId, startDate, endDate, filename);
		},
		payInvoices(){
			EventBus.$emit('pay-invoices');
		},
		moment(datetime, format='LLL'){
			moment.locale(this.$i18n.locale);
			return  moment(datetime).format(format);
		},
		__resizeHanlder: _.throttle(function (e) {
			if(this.resized) {

				this.asyncComponent = null
				this.removePeity()
				setTimeout(()=>{this.asyncComponent = 'peity'}, 1000)
			}
			this.resized = true
		}, 700),
		removePeity() {
			const peityEl = document.querySelectorAll('.widget .peity')//.forEach((el)=>{el.remove()})
			//ie fix
			for(let i=0; i<peityEl.length; i++) {peityEl[i].parentNode.removeChild(peityEl[i])}
		},
		...mapActions('genericDashboards',['fetchDashboards']),
		...mapActions('dashboardDialog', ['setCreateMode', 'setDashboardToEdit']),
		...mapActions('inventory', ['fetchInventories']),

	},
	mounted() {
		this.setPageWidth();
	},
	created () {
		if(this.customerId!=null){
			this.$store.commit('setLayout', { navPos: false });
			return CustomerAPI.getPublicCustomer(this.customerId)
				.then(customer=>{
					this.customer = customer;
										
				})
		} else if (this.isAdmin === true) {
			this.loadingInventories = true;
			this.fetchDashboards();
			this.fetchInventories()
				.then(() => {
					this.selectedReportingInventories = _.map(this.getWinePrivateImportInventories, inv => (inv.id));
					this.loadingInventories = false;
				})
			
		}
	},
	beforeDestroy () {
		if (this.customerId != null) {
			this.$store.commit('setLayout', { navPos: 'left' });
		}
	},
	components: {
		dashboardDialog,
		RepReservationsDashboard,
		CustomerPortalDocumentViewer,
		salesGraphics,
		InfoStatCard12MonthsComparison,
		ReservationStatsCard,
		VisitStatsCard,
		salesOrderDashboardCard : () => import('@/components/dashboards/sales-order/sales-order-dashboard-card.vue'),
    	reservationDashboardCard : () => import('@/components/dashboards/reservation/reservation-dashboard-card.vue'),
    	invoiceDashboardCard : () => import('@/components/dashboards/invoice/invoice-dashboard-card.vue'),
			packageDashboardCard : () => import('@/components/dashboards/package/package-dashboard-card.vue'),
	}
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';


.item {
  margin-top: 10px;
  margin-right: 40px;
  margin-bottom: 10px;
}

.dashboard-secondary-kpis {
	display: grid;
	grid-template-columns: minmax(260px, 340px) minmax(320px, 1fr);
	gap: 10px;
	align-items: stretch;
	margin: 10px;

	&__item {
		min-width: 0;
		margin: 0;
	}
}

.panorama-offer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 14px 18px;
	border: 1px solid #d6e0ff;
	background: linear-gradient(100deg, #eef4ff 0%, #f8fbff 100%);
}

.panorama-offer--animated {
	animation: panoramaOfferEntrance .9s cubic-bezier(0.2, 0.9, 0.2, 1) .08s both,
		panoramaOfferPulse 2.6s ease-in-out 1.1s infinite;
}

.panorama-offer-enter-enter-active,
.panorama-offer-enter-appear-active {
	transition: opacity .7s ease, transform .7s cubic-bezier(0.2, 0.9, 0.2, 1), filter .7s ease;
}

.panorama-offer-enter-enter,
.panorama-offer-enter-appear {
	opacity: 0;
	transform: translateY(-26px) scale(0.9);
	filter: blur(2px);
}

.panorama-offer__left {
	display: flex;
	align-items: center;
	gap: 14px;
	min-width: 0;
	flex: 1;
}

.panorama-offer__actions {
	display: flex;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
	justify-content: flex-end;
}

.panorama-offer__logo {
	width: 42px;
	height: 42px;
	flex-shrink: 0;
}

.panorama-offer__title {
	font-weight: 700;
	font-size: 16px;
	color: #2a3d5a;
}

.panorama-offer__subtitle {
	font-size: 13px;
	color: #4d5e76;
}

.customer-portal-title {
	margin: 0 0 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	font-size: 26px;
	font-weight: 700;
	line-height: 1.15;
	color: #22324a;
	text-align: center;
}

.customer-portal-title__logo {
	width: 34px;
	height: 34px;
	flex-shrink: 0;
}

.customer-invoices--centered {
	max-width: 1240px;
	margin-left: auto;
	margin-right: auto;
	padding-left: 24px;
	padding-right: 24px;
	box-sizing: border-box;
}

.panorama-offer__cta {
	padding: 8px 12px;
	border-radius: 8px;
	border: 1px solid #93a7d1;
	background: #ffffff;
	white-space: nowrap;
	font-weight: 600;
	line-height: 1;
	min-height: 36px;
	display: inline-flex;
	align-items: center;
}

.panorama-offer__cta--primary {
	background: #2f4f8d;
	border-color: #2f4f8d;
	color: #ffffff;
}

.panorama-offer__cta--secondary {
	border-color: #b8c5de;
	color: #2a3d5a;
}

@keyframes panoramaOfferGlow {
	0% {
		box-shadow: 0 0 0 rgba(47, 79, 141, 0);
	}
	45% {
		box-shadow: 0 8px 24px rgba(47, 79, 141, 0.18);
	}
	100% {
		box-shadow: 0 3px 6px rgba(40, 40, 90, 0.09), 0 1px 1px rgba(0, 0, 0, 0.065);
	}
}

@keyframes panoramaOfferEntrance {
	0% {
		opacity: 0;
		transform: translateY(-30px) scale(0.88);
	}
	68% {
		opacity: 1;
		transform: translateY(4px) scale(1.02);
	}
	100% {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

@keyframes panoramaOfferPulse {
	0%,
	100% {
		box-shadow: 0 3px 6px rgba(40, 40, 90, 0.09), 0 1px 1px rgba(0, 0, 0, 0.065);
	}
	50% {
		box-shadow: 0 14px 32px rgba(47, 79, 141, 0.24), 0 4px 10px rgba(47, 79, 141, 0.2);
	}
}


.widget {
	height: 150px;
	position: relative;

	.widget-header {

		.widget-icon-box {
			background: rgba(0, 0, 0, .02);
			border: 1px solid rgba(0, 0, 0, .02);
			border-radius: 4px;
			text-align: center;
			width: 60px;
			padding: 5px;
		}

		.widget-title {
			font-weight: bold;
		}
	}



	.badge-box {
		.badge {
			//background: rgba(0, 0, 0, .02);
			display: inline-block;
			//padding: 2px 5px;
			//border: 1px solid rgba(0, 0, 0, .02);
			border-radius: 4px;
			font-size: 80%;
		}
	}
}


/*@media (max-width: 768px) {
	.el-row {
		//margin-left: 0 !important;
		//margin-right: 0 !important;

		.el-col-24 {
			//padding-left: 0 !important;
			//padding-right: 0 !important;
		}
	}
}*/

.timeline {
	max-width: 1200px;
	margin: 6px;
}
.timeline, .timeline-title {
	color: $text-color;
	line-height: 1.4;
	cursor: default;
	font-family: inherit;
}


/*@media (min-width: 1200px) and (max-width: 1850px) {
	.widget {
		.widget-header {
			.widget-icon-box {
				display: none;
			}
		}
	}
}*/
@media (min-width: 768px) and (max-width: 1040px) {
	.radio-switcher {
		display: none;
	}

	.widget {
		.widget-header {
			.widget-icon-box {
				display: none;
			}
		}
	}
}
@media (max-width: 420px) {
	.radio-switcher {
		display: none;
	}

	.dashboard-secondary-kpis {
		grid-template-columns: minmax(0, 1fr);
	}

	.panorama-offer {
		flex-direction: column;
		align-items: flex-start;
	}

	.panorama-offer__actions {
		width: 100%;
		justify-content: flex-start;
	}
}

@media (max-width: 960px) {
	.dashboard-secondary-kpis {
		grid-template-columns: minmax(0, 1fr);
	}
}
</style>

<style lang="scss">
.page-dashboard {

	.widget {
		.peity {
			position: absolute;
			bottom: -1px;
			left: 0;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	}
	table.styled {
		.peity {
			margin-right: 10px;
		}
	}

	.vb-content {
		padding: 0 20px;
		box-sizing: border-box !important;
		margin-top: -5px;
		margin-left: -20px;
		margin-right: -20px;
		height: calc(100% + 15px) !important;
		width: calc(100% + 40px) !important;
	}
}

@media (max-width: 768px) {
	.page-dashboard {
		.vb-content {
			padding: 0 5px !important;
			margin: -5px;
			width: calc(100% + 10px) !important;
		}
	}
}
</style>
